import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import dashboardModule from './dashboard_filter';
import masterData from './masterData';
import quickAccessFavourites from './quickAccessFavourites';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    dashboardModule: dashboardModule,
    masterData: masterData,
    quickAccessFavourites: quickAccessFavourites,
  },
  plugins: [createPersistedState({
    paths: ['dashboardModule']
  })]
})
